import remoteData from "./data.json";

function generateColors(count, saturation = "95%") {
  const colors = [];
  const step = Math.floor(360 / count);

  for (let i = 0; i < count; i++) {
    colors.push([
      `hsl(${i * step}, ${saturation}, 40%)`,
      `hsl(${i * step}, ${saturation}, 30%)`
    ]);
  }

  return colors;
}

function transformData(data) {
  const colors = generateColors(data.length);

  return data.map((name, i) => ({
    name,
    id: `${name.replace("+", "plus")}-${i}`.replace(" ", "-"),
    value: 1,
    active: true,
    color: colors[i]
  }));
}

const data = [
  {
    name: "attributes",
    id: "attributes",
    data: [
      {
        name: "Light",
        value: 1,
        color: ["#DBFB5B", "#DDAC3D"],
        image: "light.png",
        active: true
      },
      {
        name: "Earth",
        value: 1,
        color: ["#5C6E3E", "#22301C"],
        image: "earth.png",
        active: true
      },
      {
        name: "Wind",
        value: 1,
        color: ["#5BCA5D", "#348D34"],
        image: "wind.png",
        active: true
      },
      {
        name: "Water",
        value: 1,
        color: ["#00B0E8", "#0064A2"],
        image: "water.png",
        active: true
      },
      {
        name: "Fire",
        value: 1,
        color: ["#FF0706", "#F97072"],
        image: "fire.png",
        active: true
      },
      {
        name: "Dark",
        value: 1,
        color: ["#A4479B", "#FE283F"],
        image: "dark.png",
        active: true
      }
    ],
    theme: "gold",
    showImage: true,
    showResult: true,
    showSetting: true
  },
  {
    name: "types",
    id: "types",
    data: [
      {
        name: "Spellcaster",
        value: 1,
        color: ["#9067D5", "#7957B4"],
        active: true
      },
      {
        name: "Plants",
        value: 1,
        color: ["#25990D", "#228B0E"],
        active: true
      },
      {
        name: "Fairy",
        value: 1,
        color: ["#B9E9FF", "#B1E0F5"],
        active: true
      },
      {
        name: "Dinosaur",
        value: 1,
        color: ["#ECBA4D", "#D0A444"],
        active: true
      },
      {
        name: "Reptile",
        value: 1,
        color: ["#5E8734", "#567B2F"],
        active: true
      },
      {
        name: "Beast-Warrior",
        value: 1,
        color: ["#9E694D", "#906046"],
        active: true
      },
      {
        name: "Aqua",
        value: 1,
        color: ["#35B1FF", "#33A8F2"],
        active: true
      },
      {
        name: "Zombie",
        value: 1,
        color: ["#443F54", "#292738"],
        active: true
      },
      {
        name: "Rock",
        value: 1,
        color: ["#8F6D46", "#4A3013"],
        active: true
      },
      {
        name: "Winged beast",
        value: 1,
        color: ["#9DFFFF", "#99FFFF"],
        active: true
      },
      {
        name: "Sea-Serpent",
        value: 1,
        color: ["#4E87D5", "#0D3D80"],
        active: true
      },
      {
        name: "Thunder",
        value: 1,
        color: ["#FFF237", "#F8D11C"],
        active: true
      },
      {
        name: "Dragon",
        value: 1,
        color: ["#FFB186", "#EBA37B"],
        active: true
      },
      {
        name: "Machine",
        value: 1,
        color: ["#B4B4B4", "#ABABAB"],
        active: true
      },
      {
        name: "Beast",
        value: 1,
        color: ["#70492A", "#674327"],
        active: true
      },
      {
        name: "Divine-Beast",
        value: 1,
        color: ["#FFFFCE", "#FDFDCC"],
        active: true
      },
      {
        name: "Wyrm",
        value: 1,
        color: ["#721515", "#6E1515"],
        active: true
      },
      {
        name: "Cabers",
        value: 1,
        color: ["#191572", "#18146E"],
        active: true
      },
      {
        name: "Psychic",
        value: 1,
        color: ["#1A9266", "#1A9165"],
        active: true
      },
      {
        name: "Fish",
        value: 1,
        color: ["#1888FC", "#0071E3"],
        active: true
      },
      {
        name: "Warrior",
        value: 1,
        color: ["#ED8AFE", "#B055D4"],
        active: true
      },
      {
        name: "Fiend",
        value: 1,
        color: ["#C797F9", "#BD92E9"],
        active: true
      },
      {
        name: "Pyro",
        value: 1,
        color: ["#FF5F41", "#D2280F"],
        active: true
      },
      {
        name: "Insect",
        value: 1,
        color: ["#322B23", "#1F1811"],
        active: true
      }
    ],
    theme: "gold",
    showType: true,
    showResult: true
  },
  {
    name: "custom",
    id: "custom",
    data: transformData(["Card 1", "Card 2", "Card 3", "Card 4"]),
    theme: "gold",
    noBorder: true,
    showText: true,
    showResult: true,
    showSetting: true,
    editable: true
  }
];

const remote = Object.keys(remoteData).map(k => {
  return remoteData[k].map(category => {
    const name = category.shift();
    return {
      name,
      id: `${k}-${name.replace("+", "plus")}`.replace(" ", "-"),
      data: transformData(category),
      theme: "gold",
      noBorder: true,
      showText: true,
      showResult: true,
      editable: true,
      group: k
    };
  });
});

const combinedData = [...data, ...remote.flat()];

export default combinedData;
